import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import { useLang } from '@/i18n';
import EfImg from '@elem/ui/ef-img';

import styles from './index.module.scss';

// const ios = (
//     <svg xmlns="http://www.w3.org/2000/svg" width="19" height="23" viewBox="0 0 19 23" fill="none">
//         <path
//             d="M15.561 12.215C15.5723 11.3641 15.8038 10.5298 16.234 9.78972C16.6643 9.04963 17.2793 8.42782 18.0218 7.98213C17.5501 7.32441 16.9278 6.78313 16.2043 6.40129C15.4809 6.01944 14.6762 5.80755 13.8542 5.78244C12.1007 5.60274 10.4007 6.80684 9.50715 6.80684C8.59631 6.80684 7.22055 5.80029 5.73907 5.83004C4.78082 5.86027 3.84692 6.13232 3.02838 6.61968C2.20984 7.10705 1.53457 7.79311 1.06835 8.61103C-0.951121 12.0246 0.55523 17.0415 2.48975 19.8008C3.45764 21.152 4.58882 22.6613 6.06896 22.6078C7.51736 22.5491 8.05831 21.7061 9.80664 21.7061C11.5388 21.7061 12.0463 22.6078 13.5564 22.5737C15.1107 22.5491 16.0899 21.2166 17.0238 19.8526C17.7192 18.8899 18.2544 17.8258 18.6094 16.6999C17.7064 16.327 16.9359 15.7029 16.3938 14.9054C15.8517 14.1079 15.5621 13.1722 15.561 12.215Z"
//             fill="black"
//         />
//         <path
//             d="M12.7104 3.96729C13.5578 2.97411 13.9753 1.69754 13.8742 0.408691C12.5796 0.541447 11.3837 1.14554 10.5248 2.10061C10.1049 2.56719 9.78328 3.11 9.57835 3.698C9.37343 4.286 9.28922 4.90766 9.33053 5.52746C9.97809 5.53397 10.6187 5.39694 11.2042 5.12669C11.7896 4.85644 12.3046 4.46002 12.7104 3.96729Z"
//             fill="black"
//         />
//     </svg>
// );

// const googlePlay = (
//     <svg xmlns="http://www.w3.org/2000/svg" width="20" height="23" viewBox="0 0 20 23" fill="none">
//         <path
//             d="M9.56861 11.3742L0.582031 21.1276C0.582875 21.1294 0.582875 21.132 0.583719 21.1337C0.859723 22.1928 1.80506 22.9722 2.92764 22.9722C3.37667 22.9722 3.79785 22.8479 4.15911 22.6304L4.1878 22.6131L14.3029 16.6445L9.56861 11.3742Z"
//             fill="#EA4335"
//         />
//         <path
//             d="M18.6588 9.71393L18.6503 9.70789L14.2832 7.11934L9.36328 11.5964L14.301 16.644L18.6444 14.0814C19.4058 13.6602 19.9232 12.8393 19.9232 11.8933C19.9232 10.9525 19.4134 10.136 18.6588 9.71393Z"
//             fill="#FBBC04"
//         />
//         <path
//             d="M0.582717 2.61675C0.528698 2.82045 0.5 3.03451 0.5 3.25547V20.4906C0.5 20.7115 0.528698 20.9256 0.583561 21.1284L9.87821 11.6244L0.582717 2.61675Z"
//             fill="#4285F4"
//         />
//         <path
//             d="M9.63529 11.8726L14.286 7.11755L4.18274 1.12739C3.81558 0.902109 3.3868 0.772639 2.92848 0.772639C1.8059 0.772639 0.858878 1.55378 0.582875 2.61371C0.582875 2.61457 0.582031 2.61543 0.582031 2.6163L9.63529 11.8726Z"
//             fill="#34A853"
//         />
//     </svg>
// );

export default function TheComp() {
    const { t } = useLang('theProduct.ExperienceApp');
    const [media, setMedia] = useState<'web' | 'ios' | 'android'>('web');
    const { locale = 'us' } = useRouter();

    // 检测当前是 pc、ios、android
    useEffect(() => {
        const userAgent = (navigator.userAgent || navigator.vendor || window.opera) as string;
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return setMedia('ios');
        } else if (/android/i.test(userAgent)) {
            return setMedia('android');
        } else {
            return setMedia('web');
        }
    }, []);

    const imgItems = {
        us: [
            'https://websiteoss.ecoflow.com/upload/image/1752811753737/Experience-App.jpg',
            'https://websiteoss.ecoflow.com/upload/image/1752811753737/Experience-App.jpg',
            'https://websiteoss.ecoflow.com/upload/image/1752811753737/Experience-App.jpg',
        ],
    } as Record<string, string[]>;

    const cardList = [
        {
            title: t('card1-title_1'),
            desc: t('card1-desc'),
        },
        {
            title: t('card1-title_2'),
            desc: t('card2-desc'),
        },
        {
            title: t('card1-title_3'),
            desc: t('card3-desc'),
        },
    ];
    return (
        <div className={`${styles.ExperienceApp}`} id="DownloadApp">
            <div className="container">
                <div className="info">
                    <div className="title">{t('title')}</div>
                    <div className="sub-title">{t('sub-title')}</div>
                    <div className="desc">{t('desc')}</div>
                    <div className="card-list">
                        {cardList.map((item, index) => (
                            <div className="card-list-item" key={index}>
                                <div className="card-title">{item.title}</div>
                                <div className="card-desc">{item.desc}</div>
                            </div>
                        ))}
                    </div>

                    <div className="download-app-links">
                        {/* <div className="btns">
                            {media !== 'android' && (
                                <div className="item app-store">
                                    <EfLink className="btn ios" href={URL.APP_IOS}>
                                        {ios}
                                        <div className="btn-text">
                                            <span>Download on the</span>
                                            <span>App Store</span>
                                        </div>
                                    </EfLink>
                                    <div className="btn-desc">{t('IOS')}</div>
                                </div>
                            )}
                            {media !== 'ios' && (
                                <div className="item">
                                    <EfLink className="btn google-play" href={URL.APP_ANDROID}>
                                        {googlePlay}
                                        <div className="btn-text">
                                            <span>GET IT ON</span>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="69" height="15" viewBox="0 0 69 15" fill="none">
                                                <path
                                                    d="M53.6027 11.3264H55.1093V1.14074H53.6027V11.3264ZM67.173 4.80973L65.446 9.22587H65.3943L63.6018 4.80973H61.9789L64.6668 10.9817L63.1351 14.4152H64.7056L68.8484 4.80973H67.173ZM58.6289 10.1694C58.1348 10.1694 57.4468 9.92088 57.4468 9.30409C57.4468 8.51864 58.3035 8.21717 59.0439 8.21717C59.706 8.21717 60.0185 8.36138 60.4206 8.55775C60.3035 9.50127 59.4985 10.1694 58.6289 10.1694ZM58.8106 4.58729C57.7197 4.58729 56.5894 5.07209 56.1227 6.14679L57.4598 6.70981C57.7456 6.14679 58.2777 5.96265 58.8364 5.96265C59.6156 5.96265 60.4076 6.43441 60.4206 7.27364V7.37793C60.1477 7.22068 59.5639 6.98521 58.8493 6.98521C57.4081 6.98521 55.9402 7.78451 55.9402 9.27802C55.9402 10.6412 57.1222 11.5195 58.4464 11.5195C59.4597 11.5195 60.0185 11.0608 60.3689 10.523H60.4206V11.3093H61.8747V7.40401C61.8747 5.596 60.5376 4.58729 58.8106 4.58729ZM49.4994 6.04983H47.3565V2.55847H49.4994C50.6257 2.55847 51.2652 3.49955 51.2652 4.30375C51.2652 5.09327 50.6257 6.04983 49.4994 6.04983ZM49.4606 1.14074H45.8506V11.3264H47.3565V7.46756H49.4606C51.1304 7.46756 52.7719 6.24701 52.7719 4.30375C52.7719 2.36048 51.1304 1.14074 49.4606 1.14074ZM29.7749 10.171C28.7341 10.171 27.8629 9.29187 27.8629 8.08435C27.8629 6.8638 28.7341 5.9708 29.7749 5.9708C30.8027 5.9708 31.6085 6.8638 31.6085 8.08435C31.6085 9.29187 30.8027 10.171 29.7749 10.171ZM31.5052 5.38008H31.4527C31.1144 4.9735 30.4644 4.60603 29.6449 4.60603C27.9275 4.60603 26.3538 6.12805 26.3538 8.08435C26.3538 10.0268 27.9275 11.5366 29.6449 11.5366C30.4644 11.5366 31.1144 11.1691 31.4527 10.7487H31.5052V11.2482C31.5052 12.5738 30.8027 13.2827 29.6707 13.2827C28.747 13.2827 28.1746 12.6129 27.9404 12.0483L26.6267 12.5999C27.0038 13.519 28.0058 14.6475 29.6707 14.6475C31.4398 14.6475 32.9359 13.5972 32.9359 11.038V4.81543H31.5052V5.38008ZM33.9767 11.3264H35.4858V1.13993H33.9767V11.3264ZM37.7094 7.96621C37.6706 6.62752 38.7373 5.94473 39.5043 5.94473C40.1034 5.94473 40.6105 6.2462 40.7792 6.67966L37.7094 7.96621ZM42.3925 6.81084C42.1066 6.0368 41.2346 4.60603 39.4526 4.60603C37.6836 4.60603 36.2141 6.00991 36.2141 8.07132C36.2141 10.0138 37.6707 11.5366 39.6214 11.5366C41.1959 11.5366 42.1066 10.5654 42.4837 10.0007L41.3129 9.21283C40.9229 9.79052 40.3892 10.171 39.6214 10.171C38.8543 10.171 38.3077 9.81659 37.9565 9.12158L42.5483 7.20439L42.3925 6.81084ZM5.80978 5.66933V7.1392H9.29542C9.19126 7.96621 8.91835 8.56997 8.50253 8.98958C7.99466 9.50208 7.20097 10.0667 5.80978 10.0667C3.66284 10.0667 1.98502 8.32064 1.98502 6.15494C1.98502 3.98842 3.66284 2.24315 5.80978 2.24315C6.96762 2.24315 7.81299 2.70269 8.43713 3.29341L9.46498 2.25619C8.59296 1.41614 7.43593 0.772461 5.80978 0.772461C2.86996 0.772461 0.398438 3.1883 0.398438 6.15494C0.398438 9.12158 2.86996 11.5366 5.80978 11.5366C7.39636 11.5366 8.59296 11.0111 9.52957 10.0268C10.4928 9.05558 10.7916 7.69081 10.7916 6.58759C10.7916 6.2462 10.7657 5.93169 10.7133 5.66933H5.80978ZM14.7552 10.171C13.7144 10.171 12.8166 9.3049 12.8166 8.07132C12.8166 6.82388 13.7144 5.9708 14.7552 5.9708C15.7952 5.9708 16.693 6.82388 16.693 8.07132C16.693 9.3049 15.7952 10.171 14.7552 10.171ZM14.7552 4.60603C12.8553 4.60603 11.3075 6.06287 11.3075 8.07132C11.3075 10.0667 12.8553 11.5366 14.7552 11.5366C16.6543 11.5366 18.2021 10.0667 18.2021 8.07132C18.2021 6.06287 16.6543 4.60603 14.7552 4.60603ZM22.2747 10.171C21.234 10.171 20.3361 9.3049 20.3361 8.07132C20.3361 6.82388 21.234 5.9708 22.2747 5.9708C23.3155 5.9708 24.2125 6.82388 24.2125 8.07132C24.2125 9.3049 23.3155 10.171 22.2747 10.171ZM22.2747 4.60603C20.3757 4.60603 18.8278 6.06287 18.8278 8.07132C18.8278 10.0667 20.3757 11.5366 22.2747 11.5366C24.1738 11.5366 25.7216 10.0667 25.7216 8.07132C25.7216 6.06287 24.1738 4.60603 22.2747 4.60603Z"
                                                    fill="black"
                                                />
                                            </svg>
                                        </div>
                                    </EfLink>
                                    <div className="btn-desc">{t('Android')}</div>
                                </div>
                            )}
                            <div className="divider"></div>
                        </div> */}
                        <div className="bj-box-h5">
                            <EfImg pc={imgItems[locale][0]} pad={imgItems[locale][1]} h5={imgItems[locale][2]} />
                        </div>

                        {/* <div className="qrcode">
                            <EfImg className="qrcode-img" pc="https://websiteoss.ecoflow.com/upload/image/1751887915215/QRcode.jpg" />
                            <div className="qrcode-desc">{t('QRCode')}</div>
                        </div> */}
                    </div>
                </div>

                <div className="bj-box">
                    <EfImg pc={imgItems[locale][0]} pad={imgItems[locale][1]} h5={imgItems[locale][2]} />
                </div>

                {/* h5-card-list */}
                <div className="card-list-h5">
                    {cardList.map((item, index) => (
                        <div className="card-list-item" key={index}>
                            <div className="card-title">{item.title}</div>
                            <div className="card-desc">{item.desc}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
